import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:ecdbf61b-750b-4b6a-8e09-7f831532985c",
    aws_user_pools_id: "ap-southeast-2_siM647N5d",
    aws_user_pools_web_client_id: "6rvbp6ekhnj4t46tn1dhfffo2j",
    Auth: {
      identityPoolId: "ap-southeast-2:ecdbf61b-750b-4b6a-8e09-7f831532985c",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_siM647N5d",
      userPoolWebClientId: "6rvbp6ekhnj4t46tn1dhfffo2j",
    },
    oauth: {
      domain: "whs-safer-beta-jp.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://beta.jp.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.jp.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve beta to "test".
  const stage = "beta".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
